<template>
    <div>
        <div v-if="dashProfile && (dashProfile.isAdmin || dashProfile.isManager)">
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-default" @click="criteria.field='sid'">SID</button>
                <button type="button" class="btn btn-default" @click="criteria.field='scode'">SCODE</button>
            </div>
            <div class="input-group">
                <input type="text" class="form-control" placeholder="Value" name="" v-model="criteria.value">
                <div class="input-group-btn">
                    <span class="btn btn-default" @click="onSearch()">{{ lang.search }}</span>
                    <!--<span class="btn btn-default">Fitler</span>-->
                    <span class="btn btn-default" @click="onSearchClear()"> {{lang.clear}} <span class="glyphicon glyphicon-remove"></span></span>
                </div>
            </div>
        </div>
        <div v-else>
            <span class="btn btn-default" @click="loadItems()">{{lang.refresh}}</span>
        </div>

        <paged-loading :is-loading="loadingImg" @pagechange="onPageChange" :paging-info="paging">
            <div>
                
                <div v-for="shop in shops" class="col-xs-12 col-sm-6 col-md-4" style="text-align:center;overflow:hidden;height:200px;display: flex;flex-direction:column;justify-content:flex-end;">
                    <div class="col-xs-12">
                        <img v-if="shop.logoPath!==null" class="img-responsive"
                             :src="shop.logoPath"
                             style="display:inline-block;height:110px;border-radius: 10px;box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.5);">
                        <div v-else >
                            <div style="height:110px;width: 110px;display:inline-block;" class="pbcss-site-logo">

                            </div>
                        </div>
                    </div>

                    <div class="col-xs-12" style="bottom:0px;background:rgba(251, 249, 249, 0.88);width:100%;text-align:center;border-right:1px solid gray;border-left:1px solid gray;">
                        <div>Code:{{shop.shopCode}} | state:{{shop.stateCode}} <span class="label label-info" v-if="shop.repShopId !==0">Agent</span></div>
                        <!-- <router-link :to="{path:'/ShopInfo',query:{shopUserId:shop.shopUserId}}">
                            <span class="btn btn-default"> {{shop.shopName}} / {{shop.domainName}}</span>
                        </router-link> -->
                        <template v-if="isSelectMode===false">
                            <!-- <router-link :to="{path:'/PostList',query:{shopUserId:shop.shopUserId}}">
                                <span class="btn btn-default"> {{shop.shopName}} / {{shop.domainName}}</span>
                            </router-link> -->
                            <router-link :to="{path:'/ShopInfo',query:{shopUserId:shop.shopUserId}}">
                                <span class="btn btn-default" style="width: 100%;"> {{shop.shopName}} / {{shop.domainName}}</span>
                            </router-link> 
                        </template>
                        <template v-else>
                            <span class="btn btn-default" @click="onSelect(shop)"> {{shop.shopName}} / {{shop.domainName}}</span>
                        </template>
                    </div>
                </div>
            </div>
        </paged-loading>
    </div>


</template>
<script>
    import pagedLoading from '../components/base/PagedLoading.vue';
    import queryString from '../utl/queryString';
    import apis from '../api/extApi.js';
    export default {
        components: {
            pagedLoading: pagedLoading
        },
        props:{
            isSelectMode:{type:Boolean,default:false}
        },
        computed: {
            dashProfile: function () {
                return this.$store.getters.dashProfile;
            },
            lang: function () {
                return this.$store.getters.lang.shopsList;
            }
        },
        data: function () {
            return {
                apiClient: apis.api,
                shops: [],
                paging: { page: 1, pageSize: 1, count: 1 },
                criteria: { value: null, field: null },
                loadingImg: false
            };
        },
        methods: {
            onSearchClear: function () {
                this.criteria.field = null;
                this.criteria.value = null;
                this.onSearch();
            },
            onSearch: function () {
                var obj = { page: 1 };
                if (this.criteria.field) {
                    obj[this.criteria.field] = this.criteria.value;
                };
                this.loadItems(queryString().getString(obj));
            },
            onSelect: function (shop) {
                this.$emit('onselect', shop);
            },
            onPageChange: function (newPage) {
                var obj = { page: newPage };
                if (this.criteria.field) {
                    obj[this.criteria.field] = this.criteria.value;
                };
                this.loadItems(queryString().getString(obj));
            },
            // onSelect: function (file) {
            //     this.$emit('onselect', file);
            // },
            loadItems: function (query) {
                var that = this;
                this.loadingImg = true;
                this.apiClient.getShopListPrms(query).done(function (ret) {
                    that.loadingImg = false;
                    var filter = ret.value.filter;
                    that.paging = { page: filter.page, pageSize: filter.pageSize, count: filter.count };
                    that.shops = ret.value.items;
                });
            }
        },
        created: function () {
            this.loadItems();
        },
        mounted: function () {

        }
    }
</script>